import {
  Box,
  Card,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ShopS3PresignedCardImage from "../../../../components/ShopS3PresignedCardImage";
import ShopS3PresignedImageLink from "../../../../components/ShopS3PresignedImageLink";
import {
  currencyFormatNoDecimals,
  currencyFormat,
} from "../../../../components/NewDetail/calculations/utils";

const BenchWork = (props) => {
  const {
    accessToken,
    benchWork,
    includeImages = true,
    isEstimate,
    showTotal = false,
    showPricePerPiece = false,
    noCalcs = false,
    isMinifiedList = false,
  } = props;
  if (!benchWork) return null;

  let trimTotalSellPrice = 0;
  for (const piece of benchWork.benchWorkPieces) {
    if (piece.calculations && piece.calculations.totalSellPrice)
      trimTotalSellPrice += parseFloat(piece.calculations.totalSellPrice);
  }

  return (
    <Box {...props}>
      {showTotal && !noCalcs ? (
        // <Typography variant="h5">
        //   Bench Work - ${Math.round(trimTotalSellPrice)}
        // </Typography>
        <Typography variant="h6">
          Bench Work -
          {currencyFormatNoDecimals(Math.round(benchWork.totalSellPrice))}
        </Typography>
      ) : (
        <Typography variant="h6">Bench Work</Typography>
      )}

      {isMinifiedList && (
        <TableContainer component={Card} sx={{ marginTop: "8px" }}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ minWidth: "150px" }}>Piece Name</TableCell>
                <TableCell align="right">Qty</TableCell>
                {showPricePerPiece && !noCalcs && (
                  <TableCell align="right">Price Per Piece</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {benchWork.benchWorkPieces.map((piece, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <ShopS3PresignedImageLink
                      linkText={piece.name}
                      s3Key={piece.image}
                      accessToken={accessToken}
                      notes={piece.notes}
                    />
                  </TableCell>
                  <TableCell align="right">{piece.quantity}</TableCell>
                  {showPricePerPiece && !noCalcs && (
                    // <TableCell align="right">
                    //   ${piece.calculations.pricePerPiece}
                    // </TableCell>
                    <TableCell align="right">
                      {currencyFormat(piece.pricePerPiece ?? 0)}
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!isMinifiedList &&
        benchWork.benchWorkPieces.map((piece, index) => (
          <Card
            key={index}
            sx={{
              marginTop: "16px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {includeImages && (
              <ShopS3PresignedCardImage
                s3Key={piece.image}
                accessToken={accessToken}
              />
            )}
            <TableContainer component={Box} sx={{ marginTop: "8px" }}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Piece Name</TableCell>
                    <TableCell align="center">Qty</TableCell>
                    {showPricePerPiece && !noCalcs && (
                      <TableCell align="center">Price Per Piece</TableCell>
                    )}
                    {/* {!isEstimate && <TableCell align="right">Sheared</TableCell>} */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {piece.name}
                    </TableCell>
                    <TableCell align="center">{piece.quantity}</TableCell>
                    {showPricePerPiece && !noCalcs && (
                      <TableCell align="center">
                        ${piece.calculations.pricePerPiece}
                      </TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ width: "100%", padding: "12px" }}>
              <Typography sx={{ fontWeight: "bold" }}>Notes:</Typography>
              <Typography sx={{ width: "100%" }}>{piece.notes}</Typography>
            </Box>
          </Card>
        ))}
    </Box>
  );
};

export default BenchWork;
